
































































































































































































































import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import { getIndexFromList, isNullOrEmpty } from '../../core/utils';
import Input from '../../core/components/Input.vue'; 
import Checkbox from '../../core/components/Checkbox.vue'; 

@Component({
    components: {
        Loading,
        Input,
        Checkbox
    }
})
export default class EditSelectedParameter extends Vue {
    @Prop() visible: boolean;
    @Prop() paramInfo: object;
    @Prop() selectedParams: any;
    @Prop() specialParams: object;
    @Prop() measuredPorts: any;
    @Prop() measuredTypes: object;
    paramsData: object = {};
    parameterIsMeasured: boolean = false;
    setAsDefaultValues: boolean = false;
    patchPendingRequest: boolean = false;
    valid: boolean = false;
    portSelected: string = '';
    loadingPatchText: string = '';
    specialParameter: string = '';
    monitorType: string = '';
    updateTime: string = '';
    minValue: any = '';
    defaultValue: any = '';
    maxValue: any = '';

    @Watch('specialParameter')
    watchSpecialParameterSelected() {
        this.validateForm();
    }

    @Watch('minValue')
    watchMinValue(val) {
        if (val === '') {
            this.minValue = null;
        }
    }

    @Watch('maxValue')
    watchMaxValue(val) {
        if (val === '') {
            this.maxValue = null;
        }
    }

    @Watch('defaultValue')
    watchDefaultValue(val) {
        if (val === '') {
            this.defaultValue = null;
        }
    }

    updateMeasuredParameter(value){
        this.parameterIsMeasured = value;
    }

    @Watch('minValue')
    @Watch('maxValue')
    @Watch('defaultValue')
    watchValues() {
        this.validateForm();
    }

    validateSpecialSelected(val) {
        // console.log("special seleccionado", val);
        //tengo que fijarme si el especial existe en los seleccionados
        //si existe tengo que fijarme que el id sea distinto al que estoy editando
        //filtro los especiales menos el que estoy editando
        if (val === '' || val == null) {
            return true;
        } else {
            let selParams = this.selectedParams.filter(item => item['id'] !== this.paramInfo['id']);
            let indexSpecialParamInSelectedOnes = getIndexFromList(selParams, 'special', val);
            if (indexSpecialParamInSelectedOnes == -1) {
                // console.log("no existe")
                return true;
            } else {
                // console.log("existe", selParams[indexSpecialParamInSelectedOnes]);
                return 'Este especial ya está asignado';
            }
        }
    }

    validateMinValue(minValue) {
        if (this.minValue === null || this.minValue === '') {
            return true;
        } else {
            if (this.minValue == null) {
                return false;
            } else {
                if (Number(minValue) <= Number(this.maxValue)) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    validateMaxValue(maxValue) {
        if (this.minValue == null || this.minValue === '') {
            return true;
        }

        if (Number(maxValue) < Number(this.minValue)) {
            return false;
        } 

        return true;        
        
    }

    validateDefaultValue(defaultValue) {
        if (defaultValue == null) {
            return true;
        } else {
            if (this.minValue && this.maxValue) {
                if (Number(defaultValue) < Number(this.minValue) || Number(defaultValue) > Number(this.maxValue)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
    }

    validateForm() {
        this.form.validate();
    }

    mounted() {
        this.resetFormValidation();
    }

    updateTimeValue(value){
        this.updateTime = value;
    }
    updateMinValue(value){
        this.minValue = value;
    }
    updateDefValue(value){
        this.defaultValue = value;
    }
    updateMaxValue(value){
        this.maxValue = value;
    }
    updateSetAsDefaultValues(value){
        this.setAsDefaultValues = value;
    }



    resetFormValidation() {
        let formElement = this.$refs.formEditSelectedParam as HTMLFormElement;
        let self = this;
        this.$nextTick(() => {
            if (formElement) {
                formElement.resetValidation();
                formElement.reset();
                setTimeout(() => {
                    self.assignFormData();
                }, 0);
            }
        });
    }

    get form(): Vue & { validate: () => boolean } {
        return this.$refs.formEditSelectedParam as Vue & { validate: () => boolean };
    }

    assignFormData() {
        this.paramsData = this.paramInfo;
        this.parameterIsMeasured = this.paramsData['measured'] !== null ? true : false;
        if (this.parameterIsMeasured) {
            this.monitorType = this.getCorrectValueForSelects(this.paramsData['measured']['type']);
            this.updateTime = this.paramsData['measured']['period'];
            this.portSelected = this.getCorrectValueForSelects(this.paramsData['measured']['port']);
        }
         this.specialParameter = this.paramsData['special'];

        this.minValue = this.paramsData['min_value'] !== null ? Number(this.paramsData['min_value']) : '';
        this.maxValue = this.paramsData['max_value'] !== null ? Number(this.paramsData['max_value']) : '';
        this.defaultValue = this.paramsData['default_value'] !== null ? Number(this.paramsData['default_value']) : '';
    }

    getCorrectValueForSelects(value: number){
        return value.toString()
    }

    // get paramHasValuesAssigned(){
    //     if(this.specialParameter || !this.minValue || this.defaultValue || this.maxValue){
    //         return true
    //     }else{
    //         return false
    //     }
    // }

    @Emit()
    closeModal() {}

    editParameter() {
        this.patchPendingRequest = true;
        this.loadingPatchText = 'Modificando parámetro...';
        let measured: null | object = null;
        let portName = this.measuredPorts.filter(item => item['id'] === this.portSelected);
        if (this.parameterIsMeasured) {
            measured = {
                port: this.portSelected,
                portName: portName[0]['value'],
                type: this.monitorType,
                period: this.updateTime
            };
        }

        


        let editedParam = {
            id: this.paramsData['id'],
            special: this.specialParameter,
            measured: measured,
            default_value: this.defaultValue !== null ? Number(this.defaultValue) : null,
            min_value: this.minValue !== null ? Number(this.minValue) : null,
            max_value: this.maxValue !== null ? Number(this.maxValue) : null
        };

        if (this.setAsDefaultValues) {
            //checkbox setear valores por defecto
            let configuration: any = {
                id: this.paramsData['id'],
                default_value: editedParam['default_value'],
                min_value: editedParam['min_value'],
                max_value: editedParam['max_value']
            };
            NormsServices.patchEditSelectedParameter(configuration)
                .then(response => {
                    // console.log("setear valores por defecto", response);
                    this.loadingPatchText = 'Parámetro modificado correctamente';
                    setTimeout(() => {
                        this.patchPendingRequest = false;
                        this.$emit('edited-selected-param', editedParam);
                        this.closeModal();
                    }, 1500);
                })
                .catch(error => {
                    // console.log("patch error", error);
                    if (error && error.response && error.response.data && error.response.data.message) {
                        this.loadingPatchText = error.response.data.message;
                    } else {
                        this.loadingPatchText = 'Ocurrió un error';
                    }
                    setTimeout(() => {
                        this.patchPendingRequest = false;
                    }, 1500);
                });
        } else {
            this.$emit('edited-selected-param', editedParam);
            this.closeModal();
        }
    }

    validateEmptyField(val) {
        if (val === '' || !val) {
            return false;
        } else {
            return true;
        }
    }
}
